"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DocumentQuickPulse.js.map